<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref='neCms' :neArr='netype' :select='neClick'></NeList>
    </template>
    <template v-slot:right_view>
      <AreaTableMenu @methodEnum='methodEnum'></AreaTableMenu>
      <AreaTable ref="areatable"></AreaTable>
    </template>
  </BasicLayout>
</template>

<script>
  import BasicLayout from '../../../../layouts/BasicLayout';
  import AreaTableMenu from '../../../../components/subscriberMicro/mcsSubscriber/area/AreaTableMenu';
  import AreaTable from '../../../../components/subscriberMicro/mcsSubscriber/area/AreaTable';
  //import NeList from '../../../../components/common/NeList';
  import NeList from '../../../../components/subscriberMicro/mcsSubscriber/NeList';


  export default {
    name: 'GroupMainPage',
    components: {
      BasicLayout,
      AreaTableMenu,
      AreaTable,
      NeList,
    },
    data() {
      return {
        left: {
          show: true,
          name: this.$t('SubscriberIms.neList')
        },
        middle: {
          show: false,
          name: ''
        },
        right: {
          show: true,
          crumb: this.$t('MCS.menuTitleAreaMcs')
        },
        netype: [
          2110//CMS
        ]
      };
    },
    methods: {
      methodEnum(opcode) {
        switch (opcode) {
          case 'add':
            this.$refs.areatable.openAddAreaPage();
            break;
          case 'mod':
            this.$refs.areatable.openModAreaPage();
            break;
          case 'del':
            this.$refs.areatable.delAreas();
            break;
          default:
        }
      },
      getNode(node) {
        this.$refs.areatable.getGridData(node);
        this.node = node;
      },
      neClick() {
        this.$refs.areatable.getGridData(this.$refs.neCms.getNe());
      },
    },
  };
</script>

<style scoped>

</style>
